import { Button, Tooltip } from '@mui/material';
import Battery2BarIcon from '@mui/icons-material/Battery2Bar';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import { Asset, BatteryLevelsEnum } from '@/types/asset_search';

export default function BatteryLevel({ asset: asset }: { asset: Asset }) {
  let icon, bgcolor, activeColor;
  switch (asset?.vehicle_level) {
    case BatteryLevelsEnum.LOW:
    case BatteryLevelsEnum.EXTREMELY_LOW:
      icon = <Battery2BarIcon sx={{ transform: 'rotate(90deg)' }} />;
      bgcolor = '#F0F2F5';
      activeColor = '#6C727A';
      break;
    default:
      icon = <BatteryFullIcon sx={{ transform: 'rotate(90deg)' }} />;
      bgcolor = '#EDFFF1';
      activeColor = '#0D852D';
      break;
  }

  if (asset.vehicle_level && asset.vehicle_level != 'No Voltage Available') {
    return (
      <Tooltip title={asset.vehicle_level}>
        <Button
          variant="outlined"
          sx={{
            borderRadius: '64px',
            paddingLeft: '5px',
            backgroundColor: bgcolor,
            maxWidth: '150px',
            textTransform: 'none',
            height: '26px',
            color: activeColor,
            borderColor: activeColor,
            textAlign: 'left',
            justifyContent: 'flex-start',
          }}
        >
          {icon} {asset.vehicle_level}
        </Button>
      </Tooltip>
    );
  } else {
    return <>--</>;
  }
}
